<template>
  <div class="section--idea-comments">
    <div class="container">
      <div class="row">
        <div class="col-md-10 offset-md-1">
          <div class="section-header">
            <h2 class="h1">Comments ({{commentCounter}})</h2>
            <button class="button-icon add-comment" @click="addingCommentActive = true">Add comment <i class="icon-comment"></i> </button>
          </div>

          <AddComment v-if="addingCommentActive" @add="refreshComments" @cancel="addingCommentActive = false"></AddComment>

          <CommentItem v-for="(comment) in comments" :comment="comment" :key="`${comment.idContentComment}+${refreshCounter}`" @refresh="getComments"></CommentItem>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddComment from "./AddComment";
import CommentItem from "./CommentItem";
export default {
name: "Comments",
  components: {CommentItem, AddComment},
  data() {
    return {
      addingCommentActive: false,
      refreshCounter: 0
    }
  },
  mounted() {
    this.getComments()
  },
  computed: {
    commentCounter() {
      return this.$store.getters.comments._total
    },
    comments() {
      return this.$store.getters.comments._embedded.ContentComment
    }
  },
  methods: {
    refreshComments() {
      this.addingCommentActive = false;
      this.getComments();
    },
    getComments() {
      this.refreshCounter = this.refreshCounter + 1;
      let payload = 0;
      if(this.$route.name === 'IdeaOverview') {
        payload= {
          idContent: this.$store.getters.idea.idContent,
          _embed: 1
        }
      }
      if(this.$route.name === 'NewsSingle') {
        payload= {
          idContent: this.$store.getters.newsSingle.idContent,
          _embed: 1
        }
      }
      this.$store.dispatch('getComments', payload)
    }
  }
}
</script>

<style scoped>

</style>
